import gql from 'graphql-tag';
import className from 'classnames/bind';
import { FormEmbedFragment } from '@graphqlTypes';
import { useEffect, useMemo, useRef } from 'react';
import { Container, SectionHeader } from '@components';

import styles from './FormEmbed.module.scss';
import Script from 'next/script';
const cx = className.bind(styles);

export default function FormEmbed({ headline, subhead, body, formId }: FormEmbedFragment) {
  const rootRef = useRef<HTMLDivElement>(null);
  const scriptSrc = `https://sfapi.formstack.io/FormEngine/Scripts/Main.js?d=${formId}`
  useEffect(() => {
    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    script.id = 'jsFastForms';
    rootRef.current?.appendChild(script);

    return () => {
      // Clean up window globals
      // @ts-ignore
      delete window.executeDefaultFormLoad;
      // @ts-ignore
      if (window.fsFormEngine) {
        // @ts-ignore
        delete window.fsFormEngine.formContainerId;
      }
    }
  }, [scriptSrc]);
  return (
    <section className={cx("form-embed")} >
      <Container>
        { headline && <SectionHeader headline={headline} /> }
        <div className={cx("content")}>
          <div className={cx("intro")}>
            { subhead && <h3 className={cx("subhead", "title-lc-m")}>{subhead}</h3> }
            { body && <div className={cx("body", "text-l", "rich-text")} dangerouslySetInnerHTML={{ __html: body }} /> }
          </div>
          <div className={cx("form")}>
            <div ref={rootRef} />
          </div>
        </div>
      </Container>
    </section>
  )
}

FormEmbed.fragments = {
  entry: gql`
    fragment FormEmbed on FlexiblePageContentContentFormEmbedLayout {
      headline
      subhead
      body
      formId
    }
  `,
};